export const deleteGenre = (allGenres, genreId) => {
  return allGenres.filter((genre) => genre._id !== genreId);
};
